import { render, staticRenderFns } from "./RevenuesTypes.vue?vue&type=template&id=624f4340&"
import script from "./RevenuesTypes.vue?vue&type=script&lang=js&"
export * from "./RevenuesTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports